<template>
    <div class="week-schedule">
        <h4 class="no-print">{{ $t('wanderManagement.schedulersTab.weekSchedule') }}</h4>
        <div v-for="(day, index) in days" :key="index" class="week-day">
            <div class="week-day-name">{{ $t(day.name) }}:</div>
            <div v-if="timeIntervals[day.index].length" class="time-interval-wrapper">
                <p v-for="(interval, index2) in timeIntervals[day.index]" :key="index2" class="time-interval">
                    {{ formatTime(interval.begin_time) }} - {{ formatTime(interval.end_time) }}
                </p>
            </div>
            <div v-if="!timeIntervals[day.index].length" class="time-interval-none">
                {{ $t('wanderManagement.schedulersTab.none') }}
            </div>
        </div>
    </div>
</template>

<script type="text/babel">
import { daysOfWeek, sortByTime } from './timeWindowHelper';
import { formatTime } from '../../../common/helpers';

export default {
    props: {
        value: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            days: daysOfWeek,
        };
    },

    computed: {
        /**
         * Filters elements from value, where day is selected day of the week, and begin end time are selected.
         * Sorts intervals by begin time.
         * @return {[Object]}
         */
        timeIntervals() {
            return this.days.map(day =>
                this.value
                    ? this.value
                          .filter(v => v.day_of_week === day.index && v.begin_time && v.end_time)
                          .map(t => ({
                              ...t,
                              begin_time: t.begin_time.slice(0, 5),
                              end_time: t.end_time.slice(0, 5),
                          }))
                          .sort(sortByTime)
                    : []
            );
        },
    },

    methods: {
        formatTime,
    },
};
</script>
